import { render } from "./MainGianHang.vue?vue&type=template&id=7b68b78f&scoped=true"
import script from "./MainGianHang.vue?vue&type=script&lang=js"
export * from "./MainGianHang.vue?vue&type=script&lang=js"

import "./MainGianHang.vue?vue&type=style&index=0&id=7b68b78f&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b68b78f"]])

export default __exports__